import { Heading } from "@elaniintc/goes-design-system";
import { ScopeField } from "../components/scope-selector";
import SwitchField from "../../form/components/SwitchField";
import { DCCondition } from "../components/condition";
import { useDataCenterNode } from "../context";

export const DCRemoveForm = () => {
  const { columnsDef, multipleSelected, setMultipleSelected } =
    useDataCenterNode();
  return (
    <>
      <div className="w-full pt-3 pb-6 px-4 border-b-1 border-neutral-quiet flex flex-col gap-1">
        <Heading variant="h6">Búsqueda de registros a eliminar</Heading>
        <div className="flex flex-col gap-4">
          <ScopeField />
          <DCCondition className="p-0" variables={columnsDef} buttonSize="xs" />
          <SwitchField
            label="Múltiples eliminaciones"
            checked={multipleSelected}
            onChange={setMultipleSelected}
            required
            switchVariant="danger"
            isFalse="No, solo el primer registro que haga match"
          />
        </div>
      </div>
    </>
  );
};
